import {useMemo} from 'react'

import {useSettingsQuery} from '../../../common/providers/ApiInterface'
import {useUrlParam} from '../../../routing'
import {getDefaultOperationTimesDtoParser} from '../utils/standardOperationTimes'

export const useDefaultAssetOperationTimesQuery = ({
  assetsIds,
  timezone_id,
  isDisabled = assetsIds.length === 0
}: {
  assetsIds: number[]
  timezone_id: string
  isDisabled?: boolean
}) => {
  const plantCode = useUrlParam('plantCode')
  const dtoParser = useMemo(() => getDefaultOperationTimesDtoParser({timezone_id}), [timezone_id])

  return useSettingsQuery('assetsStandardOperationTimes', [{assetsIds, plantCode}], {
    enabled: !isDisabled,
    select: dtoParser
  })
}
